import './splitPaneCopy.scss';
import { ClassHelpers } from '@rocketmakers/armstrong';
import * as React from 'react';
import { ImageUtils } from '../../utils/image';
import { LazyCosmosImage } from '../media/cosmosImage';
import { RMMarkdown } from '../RMMarkdown';
import { RMButton } from './rmButton';
import { SplitPane } from './splitPane';
import { VideoBackground } from './videoBackground';
export const SplitPaneCopy = ({ h1, h2, h3, p, bigP, image, button, children, video, className, floatingImage, darken, vertical, markdown, hideDecoration, ...attr }) => {
    const { contain, ...imageAttr } = !!image && image;
    return (<SplitPane alternate className={ClassHelpers.classNames('split-pane-copy', hideDecoration && 'no-decoration', className)} leftProps={{ className: 'split-pane-copy-copy' }} darken={darken} left={<div className="split-pane-copy-copy-inner">
          {h1 && <h1>{h1}</h1>}
          {h2 && <h2>{h2}</h2>}
          {h3 && <h3>{h3}</h3>}
          {p && <p data-big={bigP}>{p}</p>}
          {markdown && <RMMarkdown>{markdown}</RMMarkdown>}
          {!!button && <RMButton {...button}/>}
          {children}
        </div>} rightProps={{
        className: 'split-pane-copy-image',
        'data-contain': !!image && contain,
        'data-floating-image': floatingImage,
    }} right={image ? (<LazyCosmosImage size={ImageUtils.imageSizes.medium} {...imageAttr}/>) : video ? (<VideoBackground videoUrl={video.url} videoPosterUrl={video.posterUrl}/>) : (<div />)} vertical={vertical} {...attr}/>);
};
